<app-mobilephone-search-header
  searchPageText="Velg ny telefon"
  [detailsPageText]="isOldMobileSelected ? 'Registrer byttet' : 'Velg modell'"
  [selectedMobilePhoneVariant]="selectedMobilePhoneVariant"
  (backToMobileSearch)="selectedMobilePhoneVariant = null"
/>
<div mat-dialog-content>
  @if (!selectedMobilePhoneVariant && !data.isManualRegistration) {
    <div class="hardware-search">
      <div class="search-filter-wrapper">
        <app-mobilephone-search-filter
          [isEquipmentUpgradeEnabled]="true"
          [isLoadingFilters]="isLoadingFilters"
          [isManualRegistrationSupported]="false"
          [isMobilBytteBytte]="true"
          [manufacturers]="manufacturers"
          [searchText]="searchText"
          [selectedManufacturers]="selectedManufacturers"
          (filterChange)="onFilterChange($event)"
          (searchTextChanged)="onFilterChange($event)"
        />
      </div>
      <div class="search-result-wrapper">
        <app-hardware-search-result
          [defaultImage]="(selectedTheme$ | async).phone_illustration"
          [displayType]="displayType"
          [isLoadingSearchResults]="isLoadingSearchResults"
          [isManualRegistrationSupported]="false"
          [searchResultPhoneGroups]="mobilePhoneVariantGroupsToDisplay"
          [showEquipmentUpgradePriceOnly]="true"
          (changeDisplayType)="changeDisplay($event)"
          (itemClicked)="selectMobilephone($event)"
        />
      </div>
    </div>
  } @else {
    <app-mobilephone-mobilbytte-bytte-details
      [customer]="customerDetails()"
      [equipmentUpgradeAgreement]="equipmentUpgradeAgreement"
      [equipmentUpgradeAgreementId]="data.equipmentUpgradeAgreementId"
      [gradingQuestions]="gradingQuestions$ | async"
      [isManualRegistration]="data.isManualRegistration"
      [mobilePhoneGroupVariants]="selectedMobilePhoneVariants"
      [mobilePhoneVariant]="selectedMobilePhoneVariant"
      (backToSearch)="selectedMobilePhoneVariant = null"
      (gradingCompleted)="onGradingCompleted($event)"
      (oldMobileSelectionChanged)="isOldMobileSelected = $event"
    />
  }
</div>
